module.exports = "<div class=video-wrapper> <iframe src=\"https://www.youtube.com/embed/<%=videoId%>?rel=0&autoplay=1\" title=\"<%=title%>\" frameborder=0 allow=\"autoplay; encrypted-media\" allowfullscreen></iframe> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/cc/js/templates/youtube.html
// module id = 670
// module chunks = 2 6